import { ChevronLeft, ChevronRight } from "lucide-react";
import cn from "classnames";
import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { ConversationHistoryList } from "./conversation-history-list";

interface ConversationHistorySiderProps {
  isCollapsed: boolean;
  toggleCollapse: () => void;
  className?: string;
}

export const ConversationHistorySider: FunctionComponent<ConversationHistorySiderProps> = ({
  isCollapsed,
  toggleCollapse,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <aside
      className={cn(
        "relative shrink-0 bg-noa transition-[width] duration-200 dark:bg-noa-elevated",
        isCollapsed ? "w-0" : "w-70 border-r border-noa",
        className
      )}
    >
      {/* inert: the list is clipped to w-0 when collapsed, so keep it out of the tab order and a11y tree. */}
      <div className="h-full overflow-hidden" inert={isCollapsed}>
        <div className="h-full w-70">
          <ConversationHistoryList />
        </div>
      </div>
      <button
        type="button"
        aria-label={t(isCollapsed ? "common:expand" : "common:collapse")}
        aria-expanded={!isCollapsed}
        onClick={toggleCollapse}
        className={cn(
          "absolute top-1/2 z-10 flex size-[18px] -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border border-noa bg-noa p-0 text-noa",
          isCollapsed ? "-right-3" : "-right-[9px]"
        )}
      >
        {isCollapsed ? <ChevronRight size={10} /> : <ChevronLeft size={10} />}
      </button>
    </aside>
  );
};
